var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-grid-wrapper"},[_vm._t("default",null,{"rowClassName":_vm.getRowClassName})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }